import React from "react";
import { useFormatMessage } from "react-intl-hooks";

function Text({ id, dm }) {
  const text = useFormatMessage();
  return <>{text({ id: id, defaultMessage: dm })}</>;
}

export default Text;
